import { RoleTypeEnum } from "@/app/api/battery-portal-api";
import { LeftMenuState } from "@/common/enums/left-menu-state";
export class LoginState {
    constructor() {
        this.userId = 0;
        this.userName = "";
        this.userToken = "";
        this.firstName = "";
        this.lastName = "";
        this.useImperialMeasurementSystem = false;
        this.attemptingLogin = false;
        this.requires2FA = false;
        this.authenticated = false;
        this.mustAcceptTerms = false;
        this.roleId = null;
        this.leftMenuState = LeftMenuState.Expanded;
    }
    reset() {
        this.userName = "";
        this.userToken = "";
        this.firstName = "";
        this.lastName = "";
        this.useImperialMeasurementSystem = false;
        this.attemptingLogin = false;
        this.authenticated = false;
        this.roleId = null;
        this.leftMenuState = LeftMenuState.Expanded;
    }
    ;
    get displayName() {
        const firstName = (this.firstName || "").trim();
        const lastName = (this.lastName || "").trim();
        if (!firstName && !lastName)
            return this.userName;
        return `${this.firstName} ${this.lastName}`.trim();
    }
    get isPowerShield() {
        return this.roleId == RoleTypeEnum.Administrator || this.roleId == RoleTypeEnum.PowerUser;
    }
    ;
    get isPowerShieldAdministrator() {
        return this.roleId == RoleTypeEnum.Administrator;
    }
    ;
    get isClientAdministrator() {
        return this.isPowerShield || this.roleId == RoleTypeEnum.ClientAdministrator;
    }
    ;
    get isClientAdministratorUser() {
        return this.roleId == RoleTypeEnum.ClientAdministrator;
    }
    ;
    get isClientInstaller() {
        return this.isPowerShield || this.roleId == RoleTypeEnum.ClientInstaller || this.roleId == RoleTypeEnum.ClientAdministrator;
    }
    ;
    static fromJson(serializedState) {
        let jsonAuthModel = JSON.parse(serializedState);
        let viewModel = new LoginState();
        if (!jsonAuthModel)
            return viewModel;
        let jsonModel = jsonAuthModel.user;
        if (!jsonModel)
            return viewModel;
        viewModel.userId = jsonModel.userId || 0;
        viewModel.userName = jsonModel.userName || "";
        viewModel.userToken = jsonModel.userToken || "";
        viewModel.firstName = jsonModel.firstName || "";
        viewModel.lastName = jsonModel.lastName || "";
        viewModel.useImperialMeasurementSystem = jsonModel.useImperialMeasurementSystem || false;
        viewModel.mustAcceptTerms = jsonModel.mustAcceptTerms || false;
        viewModel.roleId = jsonModel.roleId || null;
        viewModel.leftMenuState = jsonModel.leftMenuState || LeftMenuState.Expanded;
        viewModel.attemptingLogin = false;
        viewModel.authenticated = !jsonAuthModel.requires2FA;
        return viewModel;
    }
    ;
}
